var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ErrorPage',[_vm._v("\n  疑似账号异常，无法参与此活动\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }